import { adminServerInstance } from "../axios/instances";
import { 
    CREATE_SUB_BATCH_NEW_PRE,
    CREATE_SUB_BATCH_NEW_PRE_SUCCESS,
    CREATE_SUB_BATCH_NEW_PRE_FAIL
 } from './types';

/**
 * @param {Object} params
 * @param {string} params.warehouse
 * @param {string} params.sub_batch_no
 */
export function transferSubbatchPrealert(params) {   
    return function(dispatch) {
        dispatch({type: CREATE_SUB_BATCH_NEW_PRE})
        return adminServerInstance.post(`/cargo/transferordersbywarhouseandsubbatch`, {
            ...params}, {
                timeout: 60000 * 30
            })
        .then(({data}) => {
            dispatch({
                type: CREATE_SUB_BATCH_NEW_PRE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: CREATE_SUB_BATCH_NEW_PRE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}
